// constants
import { commonImage } from 'constants/images';

// styles
import { modalBodyStyle, modalHeaderStyle, themeOptions } from 'styles';

// libraries
import styled from 'styled-components';

export const StyledManagementDetail = styled.div`
  .md-wrapper {
    &-header {
      ${modalHeaderStyle}
    }

    &-body {
      ${modalBodyStyle}

      &-content {
        &:nth-child(odd) {
          margin: 20px 0;
        }
      }
    }

    &-select,
    &-input {
      width: 248px;
    }

    &-bottom {
      display: flex;
      flex-direction: row;
      justify-content: end;
      padding: 0 30px;
    }
  }
`;

export const StyledManagementLabel = styled.p`
  width: 176px;

  > span {
    display: inline-block;
    padding: 9px 10px 9px 0;
    font-size: 14px;
    font-weight: 600;
    line-height: 21px;
  }

  &.required {
    position: relative;
    color: #000;

    > span {
      position: relative;

      &::after {
        content: '*';
        position: absolute;
        top: 8px;
        right: 2px;
        color: #de3e47;
      }
    }
  }
`;

export const StyledManagementContent = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 16px;
  // justify-content: space-between;

  .md-wrapper-body-content-box {
    /* width: 49%; */
    display: flex;

    &.address {
      width: 100%;

      > span {
        width: 176px;
      }
    }
  }
`;

export const StyledManagementBox = styled.div`
  width: 100%;
  justify-content: flex-start;

  &.address {
    display: flex;

    > div {
      width: calc(100% - 176px);
    }
  }

  &.disiciple {
    margin-top: 20px;
    position: relative;

    > span {
      display: flex;
    }
  }

  &.ci {
    display: flex;

    button.deleteButton {
      position: absolute;
      left: 10px;
      width: 16px;
      height: 16px;
      background-image: url(${commonImage.modalClose});
      background-size: 100%;
      background-repeat: no-repeat;
    }

    span + div {
      width: 100%;
    }

    .attachmentsWrap {
      position: relative;
      margin-bottom: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      padding: 11px 14px;
      border-radius: 6px;
      border: 1px solid #dadada;
      flex-direction: column;

      button.deleteButton {
        position: absolute;
        left: 0;
        width: 18px;
        height: 18px;
        background-image: url(${commonImage.modalClose});
        background-size: 100%;
        background-repeat: no-repeat;
      }

      button.downloadButton {
        position: absolute;
        right: 15px;
        width: 20px;
        height: 20px;
        background-image: url(${commonImage.fileDownload});
        background-size: 100%;
        background-repeat: no-repeat;
      }

      .custom-file-upload {
        display: block;
        width: 100%;
        cursor: pointer;
        color: #adadad;

        b {
          color: #b38b3a;
        }
      }

      /* Hide the default file input */
      #file-upload {
        display: none;
      }

      > div {
        padding-left: 25px;

        position: relative;
        margin: 10px 0;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      p {
        font-size: 14px;
        line-height: 18px;
        color: ${themeOptions.palette.gray.dark};
        span {
          display: inline-block;
          width: auto;
          padding: 0;
          margin-left: 4px;
          color: ${themeOptions.palette.gray.default};
        }
      }

      .uploadButton {
        width: 100%;
        border: none;
        padding: 3px;
      }
    }

    .downloadWrapper {
      display: flex;
      align-items: center;
      margin-top: 20px;
      margin-bottom: 20px;
      padding: 10px 10px 10px 50px;
      position: relative;
      width: 100%;
      border-radius: 6px;
      border: 1px solid #e6e6e6;
      background: #fff;

      > div {
        margin: 10px 0;
        text-align: left;
      }
    }
  }
`;
